import { Injectable, TemplateRef } from '@angular/core';
import { DialogService, DialogRef, DialogCloseResult} from '@progress/kendo-angular-dialog';

type FunctionCallback = () => void;

@Injectable({
  providedIn: 'root',
})
export class AlertService {

  constructor(private dialogService: DialogService) { }

  public alert(title: string, msg: string): void {

    const dialog: DialogRef = this.dialogService.open({
      title: title,
      content: msg,
      actions: [
          { text: 'OK', primary: true }
      ],
      width: 450,
      height: 200,
      minWidth: 250
    });

  }

  public showSuccess(msg: string): void {

    return this.alert('Éxito', msg);

  }

  public showAddSuccess(msg: string): void {

    return this.alert('Éxito', 'Se registró con éxito: \n' + msg);

  }

  public showUpdateSuccess(msg: string): void {

    return this.alert('Éxito', 'Se modificó con éxito: \n' + msg);

  }

  public showDeleteSuccess(msg: string): void {

    return this.alert('Éxito', 'Se eliminó con éxito: \n' + msg);

  }

  public showWarning(msg: string): void {

    return this.alert('Advertencia', msg);

  }

  public showError(msg: string): void {

    return this.alert('Error', msg);

  }

  public confirm(msg: string, callback?: FunctionCallback): void {
    
    const dialog: DialogRef = this.dialogService.open({
      title: 'Confirmar acción',
      content: msg,
      actions: [
          { text: 'No' },
          { text: 'Si', primary: true }
      ],
      width: 450,
      height: 200,
      minWidth: 250
    });

    dialog.result.subscribe((result) => {
      if (result instanceof DialogCloseResult) {
        console.log('close');
      } else {
        if(result.text == 'Si'){
          if(callback)
            callback();          
        }
      }
    });

  }

  public confirmDelete(msg: string, callback?: FunctionCallback): void {
    
    const dialog: DialogRef = this.dialogService.open({
      title: 'Confirmar acción',
      content: `<p>¿Esta seguro que desea eliminar el sig. registro?</p>` + msg,
      actions: [
          { text: 'No' },
          { text: 'Si', primary: true }
      ],
      width: 450,
      height: 200,
      minWidth: 250
    });

    dialog.result.subscribe((result) => {
      if (result instanceof DialogCloseResult) {
        console.log('close');
      } else {
        if(result.text == 'Si'){
          if(callback)
            callback();          
        }
      }
    });

  }

  public confirmCancel(msg: string, callback?: FunctionCallback): void {
    
    const dialog: DialogRef = this.dialogService.open({
      title: 'Confirmar acción',
      content: `<p>¿Esta seguro que desea cancelar el sig. registro?</p>` + msg,
      actions: [
          { text: 'No' },
          { text: 'Si', primary: true }
      ],
      width: 450,
      height: 200,
      minWidth: 250
    });

    dialog.result.subscribe((result) => {
      if (result instanceof DialogCloseResult) {
        console.log('close');
      } else {
        if(result.text == 'Si'){
          if(callback)
            callback();          
        }
      }
    });

  }

}
